<div class="Customers customer-company ui-g">
  <div class="ui-g ui-fluid">
    <div class="ui-g-12">
      <div>
        <div class="ui-g ui-g-nopad form-group master-data">
          <div class="ui-g-8 ui-g-nopad">
            <h1 class="step-title">{{ this.pageTitle | translate }}</h1>
          </div>

          <div class="ui-g-12 ui-lg-2 text-right">
            <button pButton type="button" class="k-generic-btn" icon="fa fa-floppy-o" iconPos="left" label="{{ 'common.save' | translate }}" (click)="save()"></button>
          </div>
        </div>
      </div>

      <div class="card">
        <form [formGroup]="formData">
          <div class="ui-g form-group master-data">
            <div [kv-form-element]="{ label: 'card.card_no', md: '4', required: true }">
              <input type="text" pInputText formControlName="cardNo" />
            </div>

            <div [kv-form-element]="{ label: 'customerDetail.surname', md: '4', required: true }">
              <input type="text" pInputText formControlName="surname" />
            </div>

            <div [kv-form-element]="{ label: 'customerDetail.name', md: '4', required: true }">
              <input type="text" pInputText formControlName="name" />
            </div>

            <div [kv-form-element]="{ label: 'customerInfoSheet.birthdayDate', md: '3', required: true }">
              <app-kv-calendar
              [inputName]="'birthDate'"
              [formData]="formData"
              [defaultDate]="maxDate"
              [maxDate]="maxDate">
              </app-kv-calendar>
            </div>

            <div class="ui-g-12">
              <hr />
            </div>
          </div>

          <div class="ui-g form-group master-data">
            <div [kv-form-element]="{ label: 'customerDetail.authorizations', md: '12' }"></div>

            <div [kv-form-element]="{ label: 'customerDetail.authorization_sendname', md: '6' }">
              <p-inputSwitch formControlName="privacyTerminal"></p-inputSwitch>
            </div>
            <div [kv-form-element]="{ label: 'customerDetail.authorization_generalcommunications', md: '6' }">
              <p-inputSwitch formControlName="privacyGenericComm"></p-inputSwitch>
            </div>
            <div [kv-form-element]="{ label: 'customerDetail.authorization_marketingresearch', md: '6' }">
              <p-inputSwitch formControlName="privacyMktgResearch"></p-inputSwitch>
            </div>
            <div [kv-form-element]="{ label: 'customerDetail.authorization_privacy', md: '6' }">
              <p-inputSwitch formControlName="privacyAuth"></p-inputSwitch>
            </div>
            <div [kv-form-element]="{ label: 'customerDetail.authorization_profiling', md: '6' }">
              <p-inputSwitch formControlName="privacyMktgProfiling"></p-inputSwitch>
            </div>
            <div [kv-form-element]="{ label: 'customerDetail.authorization_marketingactivity', md: '6' }">
              <p-inputSwitch formControlName="privacyMktgActivity"></p-inputSwitch>
            </div>
            <div [kv-form-element]="{ label: 'customerDetail.authorization_purchasecommunications', md: '6' }">
              <p-inputSwitch formControlName="privacyPurchaseCom"></p-inputSwitch>
            </div>
            <div [kv-form-element]="{ label: 'customerDetail.authorization_push', md: '6' }">
              <p-inputSwitch formControlName="privacyOptin"></p-inputSwitch>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-ext/create-customer-store-ext/create-customer-store-ext.component.html